if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      if (this.form.querySelector('[name=id]')) {
        this.form.querySelector('[name=id]').disabled = false;
      }

      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
      //this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      //this.submitButton = this.querySelector('[type="submit"]');
      //if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      const termsAndConditionCheckBox = document.querySelector('#acceptTermsAndConditions')
      if (termsAndConditionCheckBox && !termsAndConditionCheckBox.checked) {
        let lang_ar_sub = document.querySelectorAll('.lang-ar-subscription');
        if (lang_ar_sub.length) {
          this.handleErrorMessage("الرجاء قبول الشروط والأحكام");
        }
        else {
          this.handleErrorMessage("Please Accept terms and conditions");
        }
        return;
      }
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return;
      //if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();
      this.cartNotification.setActiveElement(document.activeElement);

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      const config2 = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      config2.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      delete config2.headers['Content-Type'];


      const formData = new FormData(this.form);
      formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
      //formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
      //this.cart.setActiveElement(document.activeElement);

      console.log("--- Adding to Cart ---");
      // Specific lookups for easier debugging
      console.log('Selling Plan ID:', formData.get('selling_plan'));
      console.log('Product ID:', formData.get('id'));
      console.log('Quantity:', formData.get('quantity'));

      // Log all form data
      for (var pair of formData.entries()) {
        console.log(pair[0] + ', ' + pair[1]);
      }
      console.log("----------------------");

      config.body = formData;

      // if(document.querySelector('.wisewell-model-1')) {
      //   const formData2 = new FormData();
      //   formData2.append("form_type", "product");
      //   formData2.append("utf8", '✓');
      //   // formData2.append("id", 48659543982353);
      //   // formData2.append("product-id", 9434249822481);
      //   formData2.append("sections_url", '/products/filter-subscription-1');
      //   formData2.append("sections", 'cart-notification-product,cart-notification-button,cart-icon-bubble');
      //   // formData2.append("selling_plan", 5862654225);
      //   config2.body = formData2
      //   fetch(`${routes.cart_add_url}`, config2)
      //     .then((response) => response.json())
      //     .catch((e) => {
      //       console.error(e);
      //     })
      //     .finally(() => { 
      //       fetch(`${routes.cart_add_url}`, config)
      //         .then((response) => response.json())
      //         .then((response) => {
      //           if (response.status) {
      //             this.handleErrorMessage(response.description);

      //             /* const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
      //             if (!soldOutMessage) return;
      //             this.submitButton.setAttribute('aria-disabled', true);
      //             this.submitButton.querySelector('span').classList.add('hidden');
      //             soldOutMessage.classList.remove('hidden');
      //             this.error = true; */
      //             return;
      //           } /* else if (!this.cart) {
      //             window.location = window.routes.cart_url;
      //             return;
      //           } */
      //           if(submitButton.dataset.type != 'checkout') {
      //             this.cartNotification.renderContents(response);
      //           }
      //           /* this.error = false;
      //           const quickAddModal = this.closest('quick-add-modal');
      //           if (quickAddModal) {
      //             document.body.addEventListener('modalClosed', () => {
      //               setTimeout(() => { this.cart.renderContents(response) });
      //             }, { once: true });
      //             quickAddModal.hide(true);
      //           } else {
      //             this.cart.renderContents(response);
      //           } */
      //         })
      //         .catch((e) => {
      //           console.error(e);
      //         })
      //         .finally(() => {
      //           submitButton.classList.remove('loading');
      //           submitButton.removeAttribute('aria-disabled');
      //           //if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
      //           //if (!this.error) this.submitButton.removeAttribute('aria-disabled');
      //           this.querySelector('.loading-overlay__spinner').classList.add('hidden');
      //           if(submitButton.dataset.type == 'checkout') {
      //             window.location = '/checkout'
      //           }

      //         });
      //     });
      //   } else {
      fetch(`${routes.cart_add_url}?app=salepify-custom`, config)
        .then((response) => response.json())
        .then((response) => {
          console.log("--- Add to Cart Response ---");
          console.log("Full Response:", response);
          if (response.items && response.items.length > 0) {
            const addedItem = response.items[0];
            console.log("Added Item Title:", addedItem.title);
            console.log("Selling Plan Allocation:", addedItem.selling_plan_allocation);
            console.log("Discounts:", addedItem.discounts);
            console.log("Original Price:", addedItem.original_price);
            console.log("Final Price:", addedItem.final_price);
          } else {
            // Fallback for single item response
            console.log("Selling Plan Allocation:", response.selling_plan_allocation);
            console.log("Discounts:", response.discounts);
          }
          console.log("----------------------------");
          if (response.status) {
            this.handleErrorMessage(response.description);

            /* const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true; */
            return;
          } /* else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          } */
          if (submitButton.dataset.type != 'checkout') {
            this.cartNotification.renderContents(response);
          }
          /* this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          } */
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(async () => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
          //if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          //if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          if (submitButton.dataset.type == 'checkout' && window.location.pathname.includes("products")) {
            // Salepify custom start
            if (window.tlAdvancedFreeGift && window.tlAdvancedFreeGift.rules.length) {
              await window.tlAdvancedFreeGift.updateCartData()
            }
            // Salepify custom end

            window.location = '/checkout'

            /*setTimeout(() => {
              fetch('/cart.js')
                .then(res => res.json())
                .then(cart => {
                  if (cart.items && cart.items.length > 0) {
                    window.location = '/checkout';
                  } else {
                    console.warn('Cart is still empty — redirect canceled.');
                  }
                });
            }, 500);*/
          }

        });
    }
    // }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      //if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
